import { followup as actions } from '../constants/action_types';
import * as api from '../api/api';
import * as schema from '../api/schema';
import { normalize } from 'normalizr';
import {isEmpty} from "lodash";

function getReference(getState) {
    return getState().followup.followup.reference;
}

function getReservation(getState) {
    const { result, entities } = getState().followup.followup;

    return entities.reservations[result];
}

const fetchData = reference => dispatch => {
    dispatch({
        type: actions.REQUEST,
        reference
    });

    return api.fetchData(reference)
        .then(response => response.json())
        .then(json => normalize(json.data, schema.reservation))
        .then(normalized => dispatch({
            type: actions.RECEIVE,
            data: normalized
        }))
        .catch(error => console.log(error));
};

const sendInstantMessage = (message) => (dispatch, getState) => {
    return api.postInstantMessage(getReference(getState), { message })
        .then(response => response.body)
        .then(json => normalize(json.data, schema.reservation))
        .then(data => {
            return dispatch({
                type: actions.SEND_INSTANT_MESSAGE_SUCCESS,
                data
            });
        })
        .catch(error => console.log(error));
};

const showAcceptQuotation = () => ({
    type: actions.SHOW_ACCEPT_QUOTATION
});

const cancelAcceptQuotation = () => ({
    type: actions.CANCEL_ACCEPT_QUOTATION
});

const acceptQuotation = () => (dispatch, getState) => {
    dispatch({
        type: actions.ACCEPT_QUOTATION
    });

    const data = getReservation(getState);
    const reference = getReference(getState);

    return api.acceptQuotation(reference, {
        numbering: data.numbering
    })
        .then(response => response.body)
        .then(json => normalize(json.data, schema.reservation))
        .then(data => {
            return dispatch({
                type: actions.ACCEPT_QUOTATION_SUCCESS,
                data
            });
        })
        .catch(error => {
            console.log(error);

            return dispatch({
                type: actions.ACCEPT_QUOTATION_FAILURE,
                data,
                error
            });
        });
};

const deleteDraft = (trip) => (dispatch, getState) => {
    dispatch({
        type: actions.DELETE_DRAFT,
        id: trip.id
    });

    return api.deleteDraft(trip.reference)
        .then(data => {
            return dispatch({
                type: actions.DELETE_DRAFT_SUCCESS,
                id: trip.id
            });
        })
        .catch(error => {
            return dispatch({
                type: actions.DELETE_DRAFT_FAILURE,
            });
        });
};

const showPay = () => ({
    type: actions.SHOW_PAY
});

const choosePaymentMethod = (method) => ({
    type: actions.CHOOSE_PAYMENT_METHOD,
    method
});

const fetchCreditCardFields = () => (dispatch, getState) => {
    dispatch({
        type: actions.REQUEST_CREDIT_CARD_FIELDS
    });

    return api.fetchCreditCardFields(getReference(getState))
        .then(response => response.json())
        .then(json => json.data)
        .then(data => {
            return dispatch({
                type: actions.RECEIVE_CREDIT_CARD_FIELDS,
                fields: data
            });
        });
};

const showPaymentSuccess = () => ({
    type: actions.PAYMENT_SUCCESS
});

const showPaymentFailure = () => ({
    type: actions.PAYMENT_FAILURE
});

const cancelAll = () => ({
    type: actions.CANCEL_ALL
});

const failureCancel=()=>({
    type : actions.FAILURE_CANCEL
})

const successCancel=(data)=>({
    type : actions.SUCCESS_CANCEL,
    data
})

const cancelAction = (reference, type) => (dispatch)=>{
    dispatch({type: actions.CANCEL_ACTION, reference, isReservation: type =='reservation', isQuotation: type =='quotation'});

    return api.cancelAction (reference)
        .then(response => response.body)
        .then(json => normalize(json.data, schema.reservation))
        .then(data => {
            return dispatch(successCancel(data));
        })
        .catch(error => {
            console.log(error);
            return dispatch(failureCancel());

        });
   };

const submitUpdateCancellation = (reference) => (dispatch, getState) => {
    dispatch({
        type: actions.SUBMIT_UPDATE_CANCELLATION
    });

    return api.postQuotationUpdateCancellation({reference})
        .then(response => {
            if (response.ok) {
                return dispatch({
                    type: actions.SUBMIT_UPDATE_CANCELLATION_SUCCESS,
                    data: response.body
                });
            }

            return dispatch({
                type: actions.SUBMIT_UPDATE_CANCELLATION_FAILURE,
                error: null // TODO
            });
        })
        .catch(error => {
            console.log(error);
            return dispatch({
                type: actions.SUBMIT_UPDATE_CANCELLATION_FAILURE,
                error
            });
        });
};

export {
    fetchData,
    sendInstantMessage,
    showAcceptQuotation,
    cancelAcceptQuotation,
    acceptQuotation,
    showPay,
    choosePaymentMethod,
    fetchCreditCardFields,
    showPaymentSuccess,
    showPaymentFailure,
    cancelAll,
    deleteDraft,
    cancelAction,
    submitUpdateCancellation
};
